/* eslint-disable max-len */
var UI_ARROW_RIGHT = {
  "default": 'M31.68,16.72a0,0,0,0,1,0,0l-9.91,8.89h0a1,1,0,0,1-1.41-.07,1,1,0,0,1,.08-1.42l8-7.14H1a1,1,0,0,1,0-2H28.39l-8-7.14a1,1,0,0,1-.08-1.42,1,1,0,0,1,1.41-.07l9.91,8.89v0a.81.81,0,0,1,.17.23l.07.09a1,1,0,0,1,0,.8l-.07.09A.81.81,0,0,1,31.68,16.72Z',
  globetrotter: 'M24.5 11L29.5 16M29.5 16L24.5 21M29.5 16H2.5'
};

export { UI_ARROW_RIGHT };
//# sourceMappingURL=UI_ARROW_RIGHT.js.map
